<!-- @format -->

<div class="sis-typeahead">
  @if (!control) {
    <input
      #inputElement
      class="form-control"
      type="text"
      (click)="click.emit($event)"
      [disabled]="disabled"
      [editable]="editable"
      [attr.id]="id"
      [attr.aria-describedby]="id + '_errors'"
      data-cy="typeahead-input"
      [inputFormatter]="formatInput.bind(this)"
      (keydown)="changeDetectorRef.detectChanges()"
      (keyup)="checkSearchLength($event)"
      [name]="name"
      [ngbTypeahead]="debouncedTypeahead"
      [ngClass]="class"
      [ngModel]="model"
      (ngModelChange)="onModelChange($event)"
      [placeholder]="placeholder || ''"
      [required]="required"
      [resultFormatter]="resultFormatter"
      [resultTemplate]="resultTemplate || defaultTemplate"
      (selectItem)="selectItem.emit($event)"
      (blur)="blurEvent.emit($event)" />
  }
  @if (control) {
    <input
      #inputElement
      class="form-control"
      type="text"
      (click)="click.emit($event)"
      [formControl]="control"
      [editable]="editable"
      [attr.id]="id"
      [attr.aria-describedby]="id + '_errors'"
      data-cy="typeahead-input"
      [inputFormatter]="formatInput.bind(this)"
      (keydown)="changeDetectorRef.detectChanges()"
      (keyup)="checkSearchLength($event)"
      [name]="name"
      [class.ng-touched]="control?.touched"
      [class.ng-dirty]="control?.dirty"
      [class.ng-invalid]="control?.invalid"
      [ngbTypeahead]="debouncedTypeahead"
      [ngClass]="class"
      [placeholder]="placeholder || ''"
      [resultFormatter]="resultFormatter"
      [resultTemplate]="resultTemplate || defaultTemplate"
      (selectItem)="selectItem.emit($event)" />
  }
  @if (clearable && (this.control?.value || this.modelValueSelected)) {
    <sis-button (clicked)="clear()" [class]="'clear-value'" [link]="true" [ariaLabel]="'SIS_COMPONENTS.TYPEAHEAD.CLEAR_FIELD' | translate">
      <sis-icon [icon]="'close'"></sis-icon>
    </sis-button>
  } @else {
    <sis-icon icon="search" class="search-with-svg-icon" aria-hidden="true"></sis-icon>
  }

  @if (control?.touched) {
    <sis-validation-errors [control]="control" [validationErrors]="validationErrors" [formFieldId]="id" [ariaLive]="false" />
  }
  @if (!control) {
    <sis-validation-errors [validationErrors]="validationErrors" [formFieldId]="id" [ariaLive]="false" />
  }

  <ng-template #defaultTemplate let-result="result" let-term="term">
    @if (!highlightSearchTerm) {
      <span [class.disabled]="result.disabled" data-cy="typeahead-result-item">
        <transloco [content]="resultFormatter ? resultFormatter(result) : result" />
      </span>
    }
    @if (highlightSearchTerm) {
      <ngb-highlight
        [class.disabled]="result.disabled"
        [term]="term"
        [result]="resultFormatter ? resultFormatter(result) : result"
        data-cy="typeahead-result-item"></ngb-highlight>
    }
  </ng-template>
</div>
